import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Wrench } from "lucide-react";
import { useApp } from "@/App";

const COPY = {
  ru: { section: "Зарубежные карты", title: "Технические работы", text: "Зарубежные карты временно недоступны. Мы проводим технические работы.", back: "К сервисам" },
  en: { section: "Foreign cards", title: "Under maintenance", text: "Foreign cards are temporarily unavailable while we carry out maintenance.", back: "Back to services" },
  es: { section: "Tarjetas extranjeras", title: "Trabajos técnicos", text: "Las tarjetas extranjeras no están disponibles temporalmente por mantenimiento.", back: "Volver a servicios" },
  zh: { section: "境外银行卡", title: "系统维护中", text: "境外银行卡服务正在维护，暂时无法使用。", back: "返回服务" },
};

export default function CardsMaintenancePage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { isTelegramWebApp, setBackHandler, clearBackHandler } = useApp();
  const copy = COPY[String(i18n.language || "en").split("-")[0]] || COPY.en;
  const back = useCallback(() => navigate("/services", { replace: true }), [navigate]);
  useEffect(() => {
    if (!isTelegramWebApp) return;
    setBackHandler(back);
    return () => clearBackHandler();
  }, [isTelegramWebApp, setBackHandler, clearBackHandler, back]);
  return (
    <section data-testid="cards-maintenance-page" className="flex min-h-full flex-col items-center justify-center px-6 text-center" style={{ paddingTop: 64, paddingBottom: 120 }}>
      <div className="flex h-16 w-16 items-center justify-center rounded-full" style={{ background: "#fef3c7", color: "#92400e", border: "2px solid #f59e0b" }} aria-hidden="true"><Wrench className="h-8 w-8" /></div>
      <div role="status" className="mt-5 max-w-sm rounded-xl px-4 py-3 text-base font-bold" style={{ background: "#fef3c7", color: "#78350f", border: "1px solid #f59e0b" }}>{t("cards.maintenance_unavailable")}</div>
      <p className="mt-5 text-sm text-muted-foreground">{copy.section}</p>
      <h1 className="mt-2 text-2xl font-semibold text-foreground">{copy.title}</h1>
      <p className="mt-3 max-w-sm text-sm text-muted-foreground" style={{ lineHeight: 1.6 }}>{copy.text}</p>
      <button type="button" onClick={back} className="lp-press lp-glass mt-6 rounded-xl px-5 py-3 text-sm font-semibold text-foreground" data-testid="cards-maintenance-back">{copy.back}</button>
    </section>
  );
}
